import { API_BASE } from "./api";

export async function fetchBudgets({ myaccountId, idCustomer, idShipTo }) {
    const params = new URLSearchParams({
        myaccount_id: myaccountId,
        id_customer: idCustomer,
    });
    if (idShipTo !== null && idShipTo !== undefined) {
        params.set("id_ship_to", idShipTo);
    }

    const res = await fetch(`${API_BASE}/orders-ultra/api/ws/list_budgets?${params.toString()}`);
    if (!res.ok) throw new Error("Error cargando presupuestos");
    const rows = await res.json();

    // list_budgets no hace upsert: cada guardado inserta una fila nueva sin borrar
    // las anteriores. Nos quedamos solo con la ultima fila por categoria (vienen
    // ordenadas por fecha ascendente, asi que la ultima ocurrencia es la vigente).
    const latestByCategory = {};
    (rows || []).forEach((r) => {
        latestByCategory[r.categoryId] = r;
    });
    return Object.values(latestByCategory);
}

export async function fetchBudgetConsumption({ idCustomer, idShipTo }) {
    const params = new URLSearchParams({
        id_customer: idCustomer,
        id_ship_to: idShipTo ?? 0,
    });

    const res = await fetch(`${API_BASE}/orders-ultra/api/ws/budget_consumption?${params.toString()}`);
    if (!res.ok) throw new Error("Error cargando consumo de presupuestos");
    return res.json();
}

export async function saveBudgets({ myaccountId, idCustomer, idShipTo, idEmployee, rows }) {
    const res = await fetch(`${API_BASE}/orders-ultra/api/ws/save_budgets`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            myaccountId,
            idCustomer,
            idShipTo: idShipTo ?? null,
            idEmployee,
            rows,
        }),
    });

    const text = await res.text();
    const data = JSON.parse(text);

    if (!res.ok || data.status !== "OK") {
        throw new Error(data.message || "Error guardando presupuestos");
    }

    return data;
}
